import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { AuthService } from '@core/auth/auth-service/auth-service'
import { Role } from '@core/data/models'

/**
 * Restringe una ruta a ciertos roles. Quien no encaje —incluido el usuario sin
 * rol conocido— vuelve a la raíz, que lo reparte al home que le corresponde.
 */
export const hasRoleGuard = (roles: Role[]): CanActivateFn => {
  return async () => {
    const router = inject(Router)
    const authService = inject(AuthService)

    if (!authService.currentUser()) await authService.initialize()

    const role = authService.currentUser()?.role

    if (role && roles.includes(role)) return true

    router.navigate(['/'])

    return false
  }
}
